/**
 * SAP CONFIDENTIAL
 *
 * This software is confidential proprietary software licensed by SAP SE
 * and is not to be used, duplicated or disclosed to anyone without the
 * prior written permission of SAP.
 *
 * (C) 2020 Copyright SAP SE.
 */
export class Application {
  id!: number;
  developer!: string;
  tenant!: string;
  version!: string;
  releaseDate!: string;
  constructor() {}
}
